import { Resource } from 'src/app/global/domain/resource.model';
import { Produto } from './produto.model';

export class Usuario extends Resource {
  public nome: string;
  public email: string;
  public password: string;
  public profile: string;
  public version = 0;
  constructor() {
    super();
  }
}
